import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const s = r((l, a) => /* @__PURE__ */ e.jsx(
  o,
  {
    ref: a,
    ...l,
    image: (i) => /* @__PURE__ */ e.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...i,
        children: [
          /* @__PURE__ */ e.jsx("g", { clipPath: "url(#clip0_3410_69109)", children: /* @__PURE__ */ e.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M5.179 1.43A1 1 0 0 1 6 1h4a1 1 0 0 1 .8.4L12 3h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h3.088zM8 10.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ e.jsx("defs", { children: /* @__PURE__ */ e.jsx("clipPath", { id: "clip0_3410_69109", children: /* @__PURE__ */ e.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
s.displayName = "CameraIcon";
export {
  s as CameraIcon,
  s as default
};
//# sourceMappingURL=index.js.map
